export const REQUEST_SCAN_STATUS_DATA = "REQUEST_SCAN_STATUS_DATA";
export const RECEIVE_SCAN_STATUS_DATA = "RECEIVE_SCAN_STATUS_DATA";
export const NO_RESULTS_SCAN_STATUS_DATA = 'NO_RESULTS_SCAN_STATUS_DATA';
export const ERROR_RETRIEVING_SCAN_STATUS_DATA = 'ERROR_RETRIEVING_SCAN_STATUS_DATA';

export const requestScanStatusData = payload => ({ type: REQUEST_SCAN_STATUS_DATA, payload: payload });

export const receiveScanStatusData = payload => ({ type: RECEIVE_SCAN_STATUS_DATA, payload: payload });

export const noResultsScanStatusData = payload => ({ type: NO_RESULTS_SCAN_STATUS_DATA, payload: payload });

export const errorRetrievingScanStatusData = error => ({ type: ERROR_RETRIEVING_SCAN_STATUS_DATA, payload: error });



// WEBPACK FOOTER //
// ./src/actions/scanStatusDataActions.js